// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
img {
  width: calc(82 * var(--width-ratio));
  height: calc(56 * var(--width-ratio));
  border-radius: calc(10 * var(--width-ratio));
}

.slot2 {
  margin-left: calc(12 * var(--width-ratio));
}

.tags {
  flex-wrap: wrap;
}
.tags .tag {
  margin-right: calc(8 * var(--width-ratio));
}
.tags .tag ion-icon {
  width: calc(16 * var(--width-ratio));
  height: calc(16 * var(--width-ratio));
}

/* 找parent class 有 item 的selector */
:host-context(.item) .item {
  margin-top: calc(10 * var(--width-ratio));
  margin-bottom: calc(10 * var(--width-ratio));
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/canieat-post-list/canieat-post-list.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,oCAAA;EACA,qCAAA;EACA,4CAAA;AAEF;;AACA;EACE,0CAAA;AAEF;;AAKA;EACE,eAAA;AAFF;AAIE;EACE,0CAAA;AAFJ;AAII;EACE,oCAAA;EACA,qCAAA;AAFN;;AAOA,mCAAA;AAEE;EACE,yCAAA;EACA,4CAAA;AALJ","sourcesContent":["img {\n  width: calc(82 * var(--width-ratio));\n  height: calc(56 * var(--width-ratio));\n  border-radius: calc(10 * var(--width-ratio));\n}\n\n.slot2 {\n  margin-left: calc(12 * var(--width-ratio));\n}\n\n.title {\n  //margin-left: calc(8 * var(--width-ratio));\n}\n\n.tags {\n  flex-wrap: wrap; // 若flex區塊超過長度時，自動換行\n\n  .tag {\n    margin-right: calc(8 * var(--width-ratio));\n\n    ion-icon {\n      width: calc(16 * var(--width-ratio));\n      height: calc(16 * var(--width-ratio));\n    }\n  }\n}\n\n/* 找parent class 有 item 的selector */\n:host-context(.item) {\n  .item {\n    margin-top: calc(10 * var(--width-ratio));\n    margin-bottom: calc(10 * var(--width-ratio));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
